export const GetPasswordValidationStateLength = (Password): boolean => {
    if (Password) {
        if (Password.length < 8) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

export const GetPasswordValidationStateUpperCase = (Password): boolean => {
    if (Password) {
        if ((new RegExp("[A-ZĘÓĄŚŁŻŹĆŃ]")).test(Password)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const GetPasswordValidationStateLowerCase = (Password): boolean => {
    if (Password) {
        if ((new RegExp("[a-zęóąśłżźćń]")).test(Password)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const GetPasswordValidationStateNumber = (Password): boolean => {
    if (Password) {
        if ((new RegExp("[0-9]")).test(Password)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const GetPasswordValidationStateSpecialChar = (Password): boolean => {
    if (Password) {
        if ((new RegExp("[!@#\$%\^\&*\)\(+=.,_-]")).test(Password)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const GetProfessionNumberValidationState = (didSubmit, ProfessionNumber): 'success' | 'warning' | 'error' | undefined => {
    //'success'
    //'warning'
    //'error'
    if (didSubmit === false) {
        return undefined;
    }
    if (ProfessionNumber) {
        if (ProfessionNumber.length > 0) {
            return 'success';
        } else {
            return 'error';
        }
    }
    return 'error';
}

export const GetPasswordValidationState = (didSubmit, Password): 'success' | 'warning' | 'error' | undefined => {
    if (didSubmit === false) {
        return undefined;
    }
    if (Password) {
        if (Password.length < 8) {
            return 'error';
        } else {
            return 'success';
        }
    }
    return 'error';
}

export const GetConfirmPassowrdValidationState = (didSubmit, Password, ConfirmPassword): 'success' | 'warning' | 'error' | undefined => {
    if (didSubmit === false) {
        return undefined;
    }
    if (Password && ConfirmPassword) {
        if (Password === ConfirmPassword) {
            return 'success';
        } else {
            return 'error';
        }
    }
    return 'error';
}

export const fullValidation = (Password, didSubmit, ConfirmPassword, ProfessionNumber): boolean => {
    return (GetProfessionNumberValidationState(didSubmit, ProfessionNumber) === 'success' &&
        GetPasswordValidationState(didSubmit, Password) === 'success' &&
        GetConfirmPassowrdValidationState(didSubmit, Password, ConfirmPassword) === 'success' &&
        GetPasswordValidationStateLength(Password) &&
        GetPasswordValidationStateLowerCase(Password) &&
        GetPasswordValidationStateUpperCase(Password) &&
        GetPasswordValidationStateNumber(Password) &&
        GetPasswordValidationStateSpecialChar(Password))
}

export const fullPasswordChangeValidation = (Password, ConfirmPassword, didSubmit): boolean => {
    return (GetPasswordValidationState(didSubmit, Password) === 'success' &&
        GetConfirmPassowrdValidationState(didSubmit, Password, ConfirmPassword) === 'success' &&
        GetPasswordValidationStateLength(Password) &&
        GetPasswordValidationStateLowerCase(Password) &&
        GetPasswordValidationStateUpperCase(Password) &&
        GetPasswordValidationStateNumber(Password) &&
        GetPasswordValidationStateSpecialChar(Password))
}


// WEBPACK FOOTER //
// ./src/components/Login/PasswordValidation.tsx